import { IWithSummaryModel } from "src/app/modules/common/permission/api/entity/iWithSummary.model";
import { PrescriptionDefinitionSummaryModel } from "./prescriptionDefinitionSummary.model";
import { PrescriptionDefinitionLineSummaryModel } from "./prescriptionDefinitionLineSummary.model";
export class PrescriptionDefinitionModel implements IWithSummaryModel<PrescriptionDefinitionSummaryModel> {
    summary: PrescriptionDefinitionSummaryModel;
    comment: string;
    text: string;
    lines: PrescriptionDefinitionLineSummaryModel[];
}